module.exports = __webpack_public_path__ + "img/icon-letter-u.a86ec349.svg";